// extracted by mini-css-extract-plugin
module.exports = {"TwoColumnsLayoutLine":"styles_TwoColumnsLayoutLine__RD0Xn","leftColumn":"styles_leftColumn__CIffu","item":"styles_item__YoXY6"};